import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/main-product`;

export const mainProductService = {
    listMainProduct: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-main-products`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupMainProduct: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-main-products`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    getMainProduct: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-main-product`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    }
}
